<template lang="html">
  <div class="editor_contant mal10 mar10">
    <div ref="toolbar" class="toolbar_"></div>
    <div ref="editor"  class="editor_"></div>
  </div>
</template>

<script>
import E from 'wangeditor'
import axios from 'axios'
export default {
  name: 'HdEditor',
  props: ['uploadImgServer', 'value'],
  data () {
    return {
      styleObject: {
        height: '80px',
        background: '#fff'
      },
      menus: [
        // 'head',  // 标题
        'bold', // 粗体
        // 'fontSize',  // 字号
        // 'fontName',  // 字体
        'italic', // 斜体
        'underline', // 下划线
        'strikeThrough', // 删除线
        'foreColor', // 文字颜色
        'backColor', // 背景颜色
        // 'link',  // 插入链接
        'list', // 列表
        'justify', // 对齐方式
        'quote', // 引用
        // 'emoticon',  // 表情
        'image' // 插入图片
        // 'table',  // 表格
        // 'video',  // 插入视频
        // 'code',  // 插入代码
        // 'undo',  // 撤销
        // 'redo'  // 重复
      ],
      editor: null
    }
  },
  mounted () {
    this.createdEditor()
  },
  methods: {
    createdEditor () {
      let self = this
      self.editor = new E(self.$refs.toolbar, self.$refs.editor)
      self.editor.customConfig.menus = self.menus
      self.editor.customConfig.customUploadImg = function (files, insert) {
        // let config = {
        //   headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        // }
        var formdata = new FormData()
        formdata.append('file', files[0])
        axios.post('/business/file/questionfile/image', formdata).then(res => {
          let data = res.data
          data.data.forEach(d => {
            insert(d)
          })
        })
      }
      self.listenChange()
      self.editor.create()
      if (this.value) {
        this.setHtml(this.value)
      }
    },
    setHtml (text) {
      this.editor.txt.html(text)
    },
    getHtml () {
      return this.editor.txt.html()
    },
    getText () {
      return this.editor.txt.text()
    },
    listenChange () {
      let self = this
      self.editor.customConfig.onchange = function (html) {
        // html 即变化之后的内容
        self.$emit('change')
        self.$emit('input', self.getText())
      }
    }
  }
}
</script>

<style lang="css">
.editor_contant{
  position: relative;
  z-index: 0;
  border:1px solid #eee;
  text-align: left;
}
.toolbar_{
  background: #fff;
}
.editor_{
  height: 100px;
  background: #fff;
  z-index: 0;
}
</style>
